import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Role } from '../models';

@Injectable()
export abstract class RolesService {
    abstract permissionsContains(permission: string, role?: Role): boolean;
    abstract roles(): Observable<Role[]>;
}
